import React from 'react';

const NewsItem = ({ title, main_text }) => {
  return (
    
    <div className="news-item">
      <h4>{title}</h4>
      <p>{main_text.substring(0, 100)}...

      </p>
    </div>
  );
}

export default NewsItem;
